/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N6Inputs */

const en_to_yaml_ref_n6 = /** @type {(inputs: To_Yaml_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written as a block sequence, one dash per element, not inline.`)
};

const ko_to_yaml_ref_n6 = /** @type {(inputs: To_Yaml_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인라인이 아니라 요소마다 대시 하나를 붙인 블록 시퀀스로 작성됩니다.`)
};

const ja_to_yaml_ref_n6 = /** @type {(inputs: To_Yaml_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インラインではなく、要素ごとにダッシュ 1 つのブロックシーケンスとして書かれます。`)
};

/**
* | output |
* | --- |
* | "Written as a block sequence, one dash per element, not inline." |
*
* @param {To_Yaml_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n6 = /** @type {((inputs?: To_Yaml_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n6(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n6(inputs)
	return ja_to_yaml_ref_n6(inputs)
});